// extracted by mini-css-extract-plugin
export default {"button":"ModalButton_button__KbUzY"};